import React from 'react';
import { FacebookIcon, TwitterIcon, LinkedinIcon, InstagramIcon } from 'lucide-react';
export function Footer({
  onNavigate
}: {
  onNavigate?: (page: string) => void;
}) {
  return <footer className="bg-primary pt-16 pb-8 border-t border-white/10" data-id="element-84">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-86">
          {/* Column 1: Brand */}
          <div className="col-span-2 lg:col-span-1" data-id="element-87">
            <button onClick={() => onNavigate?.('home')} className="block mb-4" data-id="element-88">
              <img src="https://cdn.magicpatterns.com/uploads/fRhFPj1omhhVd8L4VTw3h8/ChatGPT_Image_Apr_29,_2026,_09_10_58_PM.png" alt="Ambient Telecom Solutions" className="h-28 w-auto" data-id="element-89" />
            </button>
            <p className="text-slate-400 mb-6 leading-relaxed" data-id="element-90">
              Your telecom expense reduction partner. We audit bills, negotiate
              better rates, and continuously optimize your telecom spend so you
              never overpay.
            </p>
            <div className="flex space-x-4" data-id="element-91">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-slate-400 hover:bg-accent hover:text-white transition-colors" data-id="element-92">
                <LinkedinIcon className="w-5 h-5" data-id="element-93" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-slate-400 hover:bg-accent hover:text-white transition-colors" data-id="element-94">
                <TwitterIcon className="w-5 h-5" data-id="element-95" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-slate-400 hover:bg-accent hover:text-white transition-colors" data-id="element-96">
                <FacebookIcon className="w-5 h-5" data-id="element-97" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-slate-400 hover:bg-accent hover:text-white transition-colors" data-id="element-98">
                <InstagramIcon className="w-5 h-5" data-id="element-99" />
              </a>
            </div>
          </div>

          {/* Column 2: Services */}
          <div data-id="element-100">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-101">
              Business Internet
            </h4>
            <ul className="space-y-3 mb-6" data-id="element-102">
              <li data-id="element-103">
                <button onClick={() => onNavigate?.('business-internet')} className="text-slate-400 hover:text-white transition-colors" data-id="element-104">
                  Broadband Internet
                </button>
              </li>
              <li data-id="element-105">
                <button onClick={() => onNavigate?.('ethernet-fiber')} className="text-slate-400 hover:text-white transition-colors" data-id="element-106">
                  Ethernet and Fiber
                </button>
              </li>
              <li data-id="element-107">
                <button onClick={() => onNavigate?.('wireless-5g')} className="text-slate-400 hover:text-white transition-colors" data-id="element-108">
                  5G Wireless Internet
                </button>
              </li>
            </ul>

            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-109">
              Business Phone
            </h4>
            <ul className="space-y-3" data-id="element-110">
              <li data-id="element-111">
                <button onClick={() => onNavigate?.('ucaas')} className="text-slate-400 hover:text-white transition-colors" data-id="element-112">
                  UCaaS Phone System
                </button>
              </li>
              <li data-id="element-113">
                <button onClick={() => onNavigate?.('business-phone')} className="text-slate-400 hover:text-white transition-colors" data-id="element-114">
                  Voice Over IP
                </button>
              </li>
              <li data-id="element-115">
                <button onClick={() => onNavigate?.('wireless-phone')} className="text-slate-400 hover:text-white transition-colors" data-id="element-116">
                  Wireless Phone
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3: Company */}
          <div data-id="element-117">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-118">
              Company
            </h4>
            <ul className="space-y-3" data-id="element-119">
              <li data-id="element-120">
                <button onClick={() => onNavigate?.('about')} className="text-slate-400 hover:text-white transition-colors" data-id="element-121">
                  About Us
                </button>
              </li>
              <li data-id="element-122">
                <button onClick={() => onNavigate?.('suppliers')} className="text-slate-400 hover:text-white transition-colors" data-id="element-123">
                  Our Suppliers
                </button>
              </li>
              <li data-id="element-124">
                <button onClick={() => onNavigate('moving-soon')} className="text-slate-400 hover:text-white transition-colors" data-id="element-125">
                  Moving Soon
                </button>
              </li>
              <li data-id="element-126">
                <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-127">
                  Careers
                </a>
              </li>
              <li data-id="element-128">
                <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-129">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div className="col-span-2 md:col-span-1" data-id="element-130">
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-131">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-132">
              <li className="text-slate-400" data-id="element-133">
                <span className="block text-white font-medium mb-1" data-id="element-134">
                  Phone:
                </span>
                <a href="tel:+4435451747" className="hover:text-white transition-colors" data-id="element-135">
                  (443) 545-1747
                </a>
              </li>
              <li className="text-slate-400" data-id="element-136">
                <span className="block text-white font-medium mb-1" data-id="element-137">
                  Email:
                </span>
                <div className="flex flex-col space-y-1" data-id="element-138">
                  <a href="mailto:info@ambienttelecom.com" className="hover:text-white transition-colors" data-id="element-139">
                    info@ambienttelecom.com
                  </a>
                  <a href="mailto:support@ambienttelecom.com" className="hover:text-white transition-colors" data-id="element-140">
                    support@ambienttelecom.com
                  </a>
                  <a href="mailto:ambienttelecoms@gmail.com" className="hover:text-white transition-colors" data-id="element-141">
                    ambienttelecoms@gmail.com
                  </a>
                </div>
              </li>
              <li className="text-slate-400" data-id="element-142">
                <span className="block text-white font-medium mb-1" data-id="element-143">
                  Headquarters:
                </span>
                Maryland, USA
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center" data-id="element-144">
          <p className="text-slate-500 text-sm mb-4 md:mb-0" data-id="element-145">
            &copy; {new Date().getFullYear()} Ambient Telecom. All rights
            reserved.
          </p>
          <div className="flex space-x-6 text-sm" data-id="element-146">
            <a href="#" className="text-slate-500 hover:text-white transition-colors" data-id="element-147">
              Terms of Service
            </a>
            <a href="#" className="text-slate-500 hover:text-white transition-colors" data-id="element-148">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}